import React, { useState, useEffect } from "react";

import Swal from "sweetalert2";
import quotoBlueBird from "bluebird";
import { useNavigate } from "react-router-dom";
import GenerateQuote from "../../services/generatequote.service";

const parseJwt = (token) => {
  try {
    return JSON.parse(atob(token.split(".")[1]));
  } catch (e) {
    return null;
  }
};

function Lcsc() {
  let navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));
  if (user) {
    const decodedJwt = parseJwt(user.accessToken);
    if (decodedJwt.exp * 1000 < Date.now()) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Session Expire,Try Login again.",
      }).then(function () {
        navigate("/login", { replace: true });
      });
    }
  } else {
    Swal.fire({
      icon: "error",
      title: "Error",
      text: "Session Expire,Try Login again.",
    }).then(function () {
      navigate("/login", { replace: true });
    });
  }

  const [pastedData, setPastedData] = useState([]);
  const [pastedMessage, setPastedMessage] = useState(
    "Paste Your Excel Sheet Here."
  );
  const [pastedErrorMessage, setPastedErrorMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [loadingMessage, setLoadingMessage] = useState("false");
  const [style, setStyle] = useState("");
  const [manufactureNumberData, setManufactureNumberData] = useState([]);

  const changeStyle = () => {
    setStyle("border-width");
  };

  const handleDashboard = (e) => {
    navigate("/user/dashboard", { replace: true });
  };
  const partNumberRegex = /^[A-Za-z0-9\-._,\/+:;#&()\\ ]+$/;
  useEffect(() => {
    const handlePaste = (event) => {
      if (
        event.target.tagName &&
        event.target.tagName.match(/(input|textarea)/i)
      ) {
        return;
      }
      setPastedErrorMessage("");
      const clipboardData = event.clipboardData || window.clipboardData;
      const pastedText = clipboardData.getData("text");
      const rows = pastedText.split("\n");
      let result = rows.map((row) => {
        const cells = row.split("\t");
        if (cells.length > 0) {
          if (cells[0] !== "") {
            const partName = cells[0].trim();
            if (partNumberRegex.test(partName)) {
              return {
                partName: cells[0].trim(),
                color: "",
              };
            } else {
              setPastedErrorMessage("Part Number is not valid.");
              return {
                partName: partName,
                color: "errorMessage",
              };
            }
          }
        }
        return null;
      });
      result = result.filter(function (el) {
        return el != null;
      });
      if (result.length > 0) {
        setPastedMessage("");
      } else {
        setPastedMessage("Paste Your Excel Sheet Here.");
      }
      setPastedData(result);
    };
    document.addEventListener("paste", handlePaste);
    return () => {
      document.removeEventListener("paste", handlePaste);
    };
  }, []);

  const handleManufacturePartNumber = (e) => {
    if (pastedData.length === 0) {
      Swal.fire({
        title: "Error!",
        text: "Please paste proper data.",
        icon: "error",
      });
      return null;
    }
    if (pastedErrorMessage !== "") {
      Swal.fire({
        title: "Error!",
        text: pastedErrorMessage,
        icon: "error",
      });
      return null;
    }
    try {
      setLoading(true);
      setLoadingMessage("generating Quote.");
      quotoBlueBird
        .map(
          pastedData,
          async (items, i) => {
            await quotoBlueBird.delay(2000);

            let manPartNumber = "";

            let getLcscResponse = await GenerateQuote.getLcsc(items.partName);

            if (
              getLcscResponse.hasOwnProperty("data") &&
              getLcscResponse.data.hasOwnProperty("result") &&
              getLcscResponse.data.success === true
            ) {
              getLcscResponse.data.result.product_list.map((lcscItems) => {
                if (items.partName === lcscItems.number) {
                  manPartNumber = lcscItems.mpn;
                }
              });
            }

            return { [items.partName]: manPartNumber };
          },
          {
            concurrency: 1,
          }
        )
        .then((response) => {
          setManufactureNumberData(response);
          setLoading(false);
        })
        .catch((err) => {
          setLoading(false);
          Swal.fire({
            title: "Error!",
            text: err.message,
            icon: "error",
          });
        });
    } catch (err) {
      setLoading(false);
      Swal.fire({
        title: "Error!",
        text: err.message,
        icon: "error",
      });
    }
  };
  const handleReset = () => {
    setPastedData([]);
    setManufactureNumberData([]);
    setPastedMessage("Paste Your Excel Sheet Here.");
    setPastedErrorMessage("");
  };
  return (
    <div>
      {loading ? (
        <div className="loader-container">
          <div className="spinner"></div>
          <h3 className="spinnerMessage">{loadingMessage}</h3>
        </div>
      ) : (
        ""
      )}
      <div className="container">
        <div className="main-content">
          <header className="jumbotron">
            <h3 className="row justify-content-md-center">
              Get Manufacturer Part NUmber
            </h3>
          </header>
          <div style={{ maxHeight: "250px", overflow: "auto" }}>
            <table className="table">
              <thead>
                <tr key="pastData">
                  <th key="partName">Part Number</th>
                </tr>
              </thead>
              <tbody>
                {pastedData.length > 0 &&
                  pastedData.map((row, rowIndex) => (
                    <tr key={rowIndex}>
                      <td key={rowIndex + row.partName} className={row.color}>
                        {row.partName}
                      </td>
                    </tr>
                  ))}
                {pastedData.length === 0 && (
                  <tr>
                    <td className={style} onClick={changeStyle}>
                      {pastedMessage}
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
          </div>
          <button
            type="button"
            className="btn btn-outline-primary btn-sm me-1"
            onClick={handleManufacturePartNumber}
          >
            Get Manufacturer Part Number
          </button>
          <button
            type="button"
            className="btn btn-outline-warning btn-sm me-1"
            onClick={handleReset}
          >
            Reset
          </button>
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={handleDashboard}
          >
            Dashboard
          </button>
          <div>
            <div
              style={{
                maxHeight: "300px",
                overflow: "auto",
                marginTop: "12px",
              }}
            >
              <table className="table bordered">
                <thead>
                  <tr key="Manufcture Part NUmber">
                    <th key="Lcsc Part Name">Lcsc Part Number</th>
                    <th key="Manufcture Part NUmber">Manufcture Part Number</th>
                  </tr>
                </thead>
                <tbody>
                  {manufactureNumberData.length > 0 &&
                    manufactureNumberData.map((row, rowIndex) => (
                      <tr key={rowIndex + row + 1}>
                        <td key={row + Object.keys(row)[0] + 2}>
                          {Object.keys(row)[0]}
                        </td>
                        <td key={row + row[Object.keys(row)[0]] + 3}>
                          {row[Object.keys(row)[0]]}
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
export default Lcsc;
